import React from 'react';
import PropTypes from 'prop-types';
import * as smartYugikiList from '../../../constants/common/ConstSmartYugiki';

/**
 * SelectSmartYugiki
 */
class SelectSmartYugiki extends React.Component {
  render() {
    const actions = this.props.actions;

    // スマート遊技機フラグのリストに、画面表示用の"すべて"を追加する。
    let displayItemList = [{ smart_flag: '', smart_flag_mei: 'すべて' }];
    if (smartYugikiList.SMARTYUGIKI.length > 0) {
      let j = 1;
      for (let i = 0; i < smartYugikiList.SMARTYUGIKI.length; i++) {
        displayItemList[j++] = smartYugikiList.SMARTYUGIKI[i];
      }
    }

    // リストボックスの中身
    const nodes = displayItemList.map((item) => {
      return (
        <option value={item.smart_flag} key={item.smart_flag}>
          {item.smart_flag_mei}
        </option>);
    });
    const smartYugiki = this.props.data.smartYugiki;

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable"><p>スマート遊技機</p></div>
        <label className="select">
          <select name="pw_extraction_02" id="selectSmartYugiki" value={smartYugiki} onChange={e => actions.changeSmartYugiki(e.target.value)}>
            {nodes}
          </select>
        </label>
      </div>
    );
  }
}

SelectSmartYugiki.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectSmartYugiki;
